import type { AiBusinessCenterModule } from '../types'

export const reportModule: AiBusinessCenterModule = {
  key: 'report',
  label: '报表管理',
  desc: '数据报表 / 可视化分析 / 经营看板 / 指标统计',
  path: '/report',
  homePath: '/report/jmreport',
  icon: 'ep:data-analysis',
  color: '#6366f1'
}
